import { FiltrationFilter } from "../services/utils/pagination";

const isFiltrationFilter = (object?: any): object is FiltrationFilter => object?.discriminator === "FiltrationFilter";

const isFiltrationFilterArray = (object?: any): object is FiltrationFilter[] => {
  return object && Array.isArray(object) && object.every(isFiltrationFilter);
};

export { isFiltrationFilter, isFiltrationFilterArray };
